module.exports = __webpack_public_path__ + "img/map-pin.c740fd80.svg";